module.exports = __webpack_public_path__ + "img/company-one.8e8894c2.jpg";